<template>

  <div>
    <div :class="{chatBoxBtm:data.selected}" 
         v-for="(data, index) in selectedUsers.slice(0, showBoxOnDevice())" 
         class="inbox-popup-wrap" 
         :style="{ right:  ((345*index)+10)+'px' }" 
         :key="index+1">
          <div class="inbox-popup">
              <div class="inbox-popup-top">
                  <div class="inbox-popup-top-left" @click.self="$set(data, 'selected', !data.selected)">
                      <img :src="require(`@/assets/images/${data.img}`)" alt="images" />
                      <div class="inbox-popup-user">
                          <h3>{{data.name}}</h3>
                          <p>Last seen 11.43 AM</p>
                      </div>
                  </div>
                  <div class="inbox-popup-top-close" @click="removePopup(index)">
                      <img src="../../assets/icon/close-with-circle.svg" alt="icon">
                  </div>
              </div>   <!-- inbox-popup-top end -->

              <div class="inbox-popup-details" :id="'feed'+index">
                <div v-for="(msg, key) in data.messages" :key="key">
                  <div class="d-flex" :class="`${msg.id != 1 ? 'msg-left' : 'msg-right'}`">
                    <div class="img_cont_msg" >
                      <img :src="require(`@/assets/images/${data.img}`)" alt="user" v-if="msg.id!=1">
                      <img src="../../assets/images/avatar.png" alt="user" v-else>
                    </div> 
                    <div class="msg-content">
                      <div class="msg_cotainer">
                        {{msg.body}}
                      </div> 
                    </div>
                  </div>
                  <div class="message-time" :class="`${ key < data.messages.length-1 && data.messages[key+1].date == data.messages[key].date ? 'hide-time' : ''}`">
                    <p>{{ msg.date | dateFormat}}</p>
                  </div>
                </div> <!-- /.msg-left -->
              </div>
              <div class="send-popup-msg">
                  <textarea v-model="data.message"  placeholder="Type your message..." @keydown.enter="send($event,index)"></textarea>
                  <img src="../../assets/icon/paperclip.png" alt="paperclip" class="paperclip">
                  <button type="submit" class="smaller-send-arrow" @click="send($event, index)">
                      <img src="../../assets/icon/smaller-send-arrow.svg" alt="smaller-send-arrow" >
                  </button>
              </div>
          </div>   
    </div>
    <div>
      <div v-if="selectedUsers.length>showBoxOnDevice()" class="more-chat-box" :style="{ right:  ((345*showBoxOnDevice())+30)+'px' }"  @click.self="chatBoxToggle">
        <img src="../../assets/icon/message-square.svg" alt="msg" @click.self="chatBoxToggle">
        
          <ul v-if="isHidden==true" class="hiddenBoxUser">
            <li class="singleHiddenBoxUser" v-for="(data, key) in selectedUsers.slice(showBoxOnDevice(), selectedUsers.length)" :key="key" @click.self="openChatBox(key, data)">
              {{ data.name | shortDes }} 
              <i class="fas fa-times-circle" @click="removePopup(key+showBoxOnDevice())"></i>
            </li>
          </ul>
      </div>
    </div>
  </div>


</template>

<script>

    import { EventBus } from '../../main';
    import moment from 'moment';
    
    export default {

        name: "chat-box",

        data() {
          return {
            selectedUsers:[],
            isHidden:false,
            window: {
              width: 0
            }
          }
        },

        methods: {

            removePopup(index){
              this.selectedUsers.splice(index, 1)
            },

             chatBoxToggle() {
                return this.isHidden = !this.isHidden;
             },
             
            //show number or box based on device width
            showBoxOnDevice() {
              if(this.window.width<992) {
                return 1;
              } else if(this.window.width<1380)  {
                return 2;
              } else if(this.window.width<1800)  {
                return 3;
              } else {
                return 4;
              }
            },

            send(e,index) {

              e.preventDefault();
              if(this.selectedUsers[index].message == ''){
                return;
              } else {
                this.selectedUsers[index].messages.push({body:this.selectedUsers[index].message, id:1, date:moment().format('LLLL')})
              }
              this.selectedUsers[index].message='';
              this.scrollToBottom('feed'+index);
            
            },


            scrollToBottom(val) {
              setTimeout(()=>{
                 document.getElementById(val).scrollTop = document.getElementById(val).scrollHeight;
              },50);
            },


            openChatBox(index,data){
              console.log(data,index);
            },

            // get device size
            handleResize() {
              this.window.width = window.innerWidth;
            }


        },

      
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },

        created() {
          window.addEventListener('resize', this.handleResize)
          this.handleResize();
          
          EventBus.$on('message', data => {
            this.selectedUsers.push(data);
          });

        }


    }

</script>

<style>
    @import '../../assets/css/chat-box.css';
    .more-chat-box {
      position: fixed;
      background: #ffffff;
      width: 50px;
      height: 45px;
      text-align: center;
      line-height: 50px;
      bottom: 0;
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
      box-shadow: 0px 0px 8px #dcdcdc;
      cursor: pointer;
  }
  .hiddenBoxUser {
        position: absolute;
        bottom: 40px;
        right: 0px;
        min-width: 220px;
        background: #fff;
        border-radius: 4px;
        margin: 0;
        padding: 0;
        list-style: none;
        text-align: left;
      padding: 10px 0px;
  }

  .hiddenBoxUser>li {
      line-height: 38px;
      padding: 0px 15px;
      position: relative;
      transition: .5s;
  }

  .hiddenBoxUser>li i {
        position: absolute;
        right: 10px;
        top: 15px;
        font-size: 12px;
  }

  .hiddenBoxUser>li:hover{
    background: #ddd;
  }
  /*  

    .singleHiddenBoxUser {
        text-align: left;
        padding: 0px 10px;
        transition: .5s;
        position: relative;
        font-size: 14px;
        line-height: 29px;
    }
    .singleHiddenBoxUser>i {
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 12px;
    }
    .singleHiddenBoxUser:hover{
      background: #ddd;
    }*/

    .inbox-popup .message-time>p {
      font-size: 10px;
      line-height: 25px;
      padding: 0px 10px;
      margin-top: 8px;
  }

  .inbox-popup .hide-time{
    display: none;
  }
</style>


